import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import ButtonAdd from "../../components/main/ButtonAdd";
import AgencyAction from "../../components/action/AgencyAction";

export const HeaderAgency = [
    {
        Header: "Nome azienda",
        accessor: "nome",
        disableSortBy: true,
        Filter: false,
        customSort: false
    },
    {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Filter: false,
        customSort: false,
        Cell: ({ row }: any) => (
            <div className="flex space-x-1 justify-end px-5">
                <ButtonAdd 
                    icon={<PencilSquareIcon className="w-6 h-6" />} 
                    path={`/dashboard/agency/update/${row?.original?.id}`} 
                    label={'Aggiungi agenzia'} 
                />
                <AgencyAction type="delete" icon={<TrashIcon className="w-5 h-5" />} idAzienda={row.original.id} infoForm={row.original} />
            </div>
        )
    }
]